import { ParentContext } from 'global/cnr/contexts/ParentContext'
import UiSaveButtons from 'global/components/buttons/UiSaveButtons'
import AppForm from 'global/components/forms/appForms/AppForm'
import CopyPaste from 'global/components/pasting/CopyPaste'
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths'
import FullPageWrapper from 'global/wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import _ from 'lodash'
import { useContext, useEffect, useState } from 'react'
import { golfAppForms } from '../helpers/golfFormProps'
import { writeBatch } from 'firebase/firestore'

export const GolferAdd = ({ currentGolfer, handleCancel, currentGolfers, teams }) => {

  const parentContext = useContext(ParentContext)
  const { states: states_parent, fns: fns_parents } = parentContext ?? {}
  const { database_fns, navigation_fns } = fns_parents
  const { paps_state, app_state, currentSettings_state } = states_parent
  const { pathViews } = paps_state ?? {}
  const { mainDb } = app_state ?? {}

  const [showPaste, setShowPaste] = useState()
  const [pastedGolfers, setPastedGolfers] = useState()
  const [updating, setUpdating] = useState()
  const [_currentGolfer, setCurrentGolfer] = useState(_.cloneDeep(currentGolfer))
  const [golferReady, setGolferReady] = useState()
  const [missingGolfers, setMissingGolfers] = useState({})

  useEffect(() => {
    if (currentGolfers) {
      const missingGolfers = _.pickBy(
        currentGolfers,
        g => !g.firstName || !g.lastName
      )
      setMissingGolfers(missingGolfers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentGolfers]);

  const isValid = (obj, items) => {
    return _.every(items, (key) => {
      return _.has(obj, key) && !_.isEmpty(_.trim(obj[key]));
    });
  };

  const handleMissingGolfers = async () => {
    setUpdating(true);
    try {
      const deletes = []
      const batch = writeBatch(mainDb);
      _.map(missingGolfers, (golfer, gk) => {
        const refPath = createRefPath_event(pathViews, ['golfers', gk]);
        deletes.push({ gk, refPath, golfer })
        return database_fns.delete_doc(refPath, golfer, null, batch);
      })
      batch.commit()
      console.log('deletes', deletes);
    } catch (error) {
      console.error("Error adding golfers:", error);
    } finally {
      setUpdating(false);
    }
  };

  const handleSaveHandicap = () => {
    const refPath = createRefPath_event(pathViews, ['golfers'])
    // database_fns.add_doc(refPath, _currentGolfer)
    handleCancel(false)
  }

  const handleSaveHandicaps = async (golfers) => {
    setUpdating(true);
    const adds = []
    try {
      const refPath = createRefPath_event(pathViews, ['golfers']);

      const batch = writeBatch(mainDb);
      _.map(golfers, (golfer) => {
        adds.push(golfer)
        return database_fns.add_doc(refPath, golfer, null, batch);
      })
      batch.commit()
      handleCancel(false); // only after all docs saved
    } catch (error) {
      console.error("Error saving handicaps:", error);
    } finally {
      setUpdating(false);
    }
  };


  const handleUpdateGolfer = (d) => {
    setCurrentGolfer(d)
    const x = isValid(d, ['firstName', 'lastName', 'handicapIndex', 'handicapSourceType'])
    console.log('z', x, d)
    setGolferReady(isValid(d, ['firstName', 'lastName', 'handicapIndex', 'handicapSourceType']))
  }

  const normalizePlayers = (input) => {
    if (_.isArray(input)) {
      return input;
    }
    if (_.isObject(input)) {
      return _.values(input); // extract objects from keys
    }
    return [];
  };

  const newGolfers = (ngs, egs) => {
    const playersA = normalizePlayers(ngs);
    const playersB = normalizePlayers(egs);
    return _.differenceWith(
      playersA,
      playersB,
      (a, b) =>
        _.toLower(a.firstName) === _.toLower(b.firstName) &&
        _.toLower(a.lastName) === _.toLower(b.lastName)
    );
  }

  const playersWithTeams = (players, existingTeams) =>
    _.map(players, (player) => {
      const matchedKeys = _.chain(existingTeams)
        .values()
        .filter((team) => _.toLower(team.name) === _.toLower(player.teamName))
        .map('_itemKey')
        .value();

      // explicitly omit teamName
      return {
        firstName: player.firstName,
        lastName: player.lastName,
        handicapIndex: 0,
        handicapSourceType: 'USGA',
        teams: matchedKeys
      };
    });


  const playersWithTeamsXXX = (players, existingTeams) =>
    _.map(players, (player) => {
      // find all team objects that match the player's teamName
      const matchedKeys = _.chain(existingTeams)
        .values() // grab the team objects
        .filter((team) => _.toLower(team.name) === _.toLower(player.teamName))
        .map('_itemKey') // pluck the _itemKey field
        .value();

      return {
        ...player,
        handicapIndex: 0,
        handicapSourceType: 'USGA',
        teams: matchedKeys
      };
    });


  const handlePasted = (golfers) => {
    const ngs2 = newGolfers(golfers, currentGolfers)
    const ngs1 = playersWithTeams(ngs2, teams)
    setPastedGolfers(ngs1)
    handleSaveHandicaps(ngs1)
    handleShowPaste()
  }

  const handleShowPaste = () => setShowPaste(!showPaste)

  const appForm_handicap = () => {
    const handicapFormItems = golfAppForms().golfer
    return <AppForm
      data_parent={_currentGolfer}
      appFormItems={handicapFormItems}
      handleUpdateParentData={handleUpdateGolfer}
    />
  }

  const handicapFooter = () => {
    const btns = []
    btns.push({ oc: handleShowPaste, icon: 'arrow right', caption: 'Show Paste', color: 'blue', fl: true })
    btns.push({ oc: handleSaveHandicap, icon: 'save', caption: 'Add Golfer', color: 'green', disabled: !golferReady })
    btns.push({ oc: handleMissingGolfers, icon: 'delete', caption: 'Remove Golfers (' + _.size(missingGolfers) + ')', color: 'red', disabled: _.isEmpty(missingGolfers) })
    return <UiSaveButtons others={btns} />
  }

  const golfer_add = () => <Wrapper
    content={appForm_handicap()}
    wrapperType={wrapperTypes.paddedHeader}
    updating={updating}
    footer={handicapFooter()}
    css={{ header: 'glf-hdr', container: 'app-dark-mode' }}
  />

  const fpw = () => <FullPageWrapper
    topperCaption={showPaste ? 'Add Golfers' : 'Add Golfer'}
    content={showPaste ? <CopyPaste handleCancel={handleShowPaste} handleUpdate={handlePasted} /> : golfer_add()}
    handleCancel={handleCancel}
  ></FullPageWrapper>

  return fpw()

}
